module.exports = __webpack_public_path__ + "img/profile-agustin.923887c4.webp";